import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER, ErrorHandler } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// import {
//   ApplicationInsightsModule,
//   AppInsightsService,
// } from '@markpieszak/ng-application-insights';
import { AppInsightsModule } from 'projects/bis-shared/src/lib/logging/app-insights-shared-module';
import { AppRoutingModule } from './app-routing.module';
import { MaterialModule } from 'projects/bis-shared/src/lib/material/material.module';
import { LookupModule } from 'projects/bis-shared/src/lib/lookup/lookup.module';
import { AppComponent } from './app.component';
import { NavigationComponent } from './navigation/navigation.component';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HttpStatusInterceptor } from 'projects/bis-shared/src/lib/http-interceptors/http-status.interceptor';
import { DatatableModule } from 'projects/bis-shared/src/lib/datatable/datatable.module';
import { DialogModule } from 'projects/bis-shared/src/lib/dialog/dialog.module';
import { AuthModule } from 'projects/bis-shared/src/lib/auth/auth.module';
import { StoreModule } from '@ngrx/store';
import { httpRequestCountReducer } from 'projects/bis-shared/src/lib/redux/http-status/http-status.reducer';
import { NotFoundModule } from 'projects/bis-shared/src/lib/not-found/not-found.module';
import { HttpErrorInterceptor } from 'projects/bis-shared/src/lib/http-interceptors/http-error.interceptor';
import { SnackbarComponent } from 'projects/bis-shared/src/lib/snackbar/snackbar/snackbar.component';
import { FooterComponent } from './footer/footer.component';
import { UtilityModule } from 'projects/bis-shared/src/lib/utility/utility.module';
import { HttpJsonInterceptor } from 'projects/bis-shared/src/lib/http-interceptors/http-json.interceptor';
import { HttpTokenInterceptorService } from 'projects/bis-shared/src/lib/http-interceptors/http-token-interceptor.service';
import { HttpResponseInterceptor } from 'projects/bis-shared/src/lib/http-interceptors/http-response.interceptor';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LandingComponent } from './landing/landing.component';
import { HealthcareProviderDashboardComponent } from './dashboard/healthcare-provider-dashboard/healthcare-provider-dashboard.component';
import { ConfigService, LoggingLevel } from 'projects/bis-shared/src/lib/config-service';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { DraftEformsQueueComponent } from './eform-queues/draft-eforms-queue/draft-eforms-queue.component';
import { SubmittedEformsQueueComponent } from './eform-queues/submitted-eforms-queue/submitted-eforms-queue.component';
import { MyGroupsComponent } from './my-groups/my-groups.component';
import { BreadcrumbModule } from 'projects/bis-shared/src/lib/breadcrumb/breadcrumb.module';
import { RecentDownloadsComponent } from './recent-downloads/recent-downloads/recent-downloads.component';
import { PriorAuthQueueComponent } from './prior-auth-queue/prior-auth-queue.component';
import { ActivePriorAuthListProviderComponent } from './prior-auth-queue/active-prior-auth-list-provider/active-prior-auth-list-provider.component';
import { ActivePriorAuthListInsurerMyOrgComponent } from './prior-auth-queue/active-prior-auth-list-insurer-my-org/active-prior-auth-list-insurer-my-org.component';
import { ActivePriorAuthListInsurerMyParsComponent } from './prior-auth-queue/active-prior-auth-list-insurer-my-pars/active-prior-auth-list-insurer-my-pars.component';
import { InActivePriorAuthListComponent } from './prior-auth-queue/inactive-prior-auth-list/inactive-prior-auth-list.component';
import { BulkEditObjectsComponent } from './bulk-edit-objects/bulk-edit-objects.component';
import { DynamicFormsModule } from 'projects/bis-shared/src/lib/dynamic-forms/dynamic-forms.module';
import { SnackbarService } from 'projects/bis-shared/src/lib/snackbar/snackbar.service';
import { BulkEditObjectService } from './bulk-edit-objects/bulk-edit-object.service';
import { AssigneeModalComponent } from './prior-auth-queue/assignee-modal/assignee-modal.component';
import { UtilizationReviewerDashboardComponent } from './dashboard/utilization-reviewer-dashboard/utilization-reviewer-dashboard.component';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { GlobalErrorHandler } from 'projects/bis-shared/src/lib/logging/global-error-handler';
import { SsoComponent } from './sso/sso.component';
import { PriorAuthSearchComponent } from './prior-auth-queue/prior-auth-search/prior-auth-search.component';
import { ModalComponent } from './modal/modal.component';
import { MatIconModule } from '@angular/material/icon';
import { BadgesModule } from 'projects/bis-shared/src/lib/badge/badge.module';
import { CommonModule } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { provideEnvironmentNgxMask } from 'ngx-mask';

// eslint-disable-next-line func-style
export function loadConfig(http: HttpClient, config: ConfigService): () => Promise<boolean> {
  return (): Promise<boolean> =>
    new Promise<boolean>(resolve => {
      // TODO: Make this environment-aware
      http
        .get('config/loggerconfig.json')
        .pipe(
          map((c: ConfigService) => {
            config.loggingLevel = c.loggingLevel;
            config.printToConsole = c.printToConsole;
            resolve(true);
          }),
          catchError(() => {
            config.loggingLevel = LoggingLevel.None;
            config.printToConsole = false;
            resolve(true);
            return of({});
          }),
        )
        .subscribe();
    });
}

@NgModule({ declarations: [], bootstrap: [AppComponent], imports: [AppComponent,
  CommonModule,
  BrowserModule,
  DynamicFormsModule,
  BreadcrumbModule,
  AppRoutingModule,
  BrowserAnimationsModule,
  MaterialModule,
        //NgIdleKeepaliveModule.forRoot(),
        // ApplicationInsightsModule.forRoot({
        //     instrumentationKeySetLater: true,
        // }),
  AppInsightsModule,
  DatatableModule,
  DialogModule,
  AuthModule,
  StoreModule.forRoot({
    httpRequestCount: httpRequestCountReducer,
  }),
  NotFoundModule,
  UtilityModule,
  LookupModule,
  MatIconModule,
  BadgesModule,
        //AppComponent,
  NavigationComponent,
  FooterComponent,
  SnackbarComponent,
  DashboardComponent,
  MyGroupsComponent,
  LandingComponent,
  SsoComponent,
  DraftEformsQueueComponent,
  SubmittedEformsQueueComponent,
  RecentDownloadsComponent,
  PriorAuthQueueComponent,
  ActivePriorAuthListInsurerMyOrgComponent,
  ActivePriorAuthListProviderComponent,
  ActivePriorAuthListInsurerMyParsComponent,
  InActivePriorAuthListComponent,
  AssigneeModalComponent,
  UtilizationReviewerDashboardComponent,
  PriorAuthSearchComponent,
  ModalComponent,
  MatToolbarModule,
  HealthcareProviderDashboardComponent,
  BulkEditObjectsComponent,
],
providers: [
  BulkEditObjectService,
        //AppInsightsService,
  SnackbarService,
  {
    provide: HTTP_INTERCEPTORS,
    useClass: HttpResponseInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: HttpStatusInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: HttpTokenInterceptorService,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: HttpErrorInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: HttpJsonInterceptor,
    multi: true,
  },
  {
    provide: ErrorHandler,
    useClass: GlobalErrorHandler,
  },
  {
    provide: APP_INITIALIZER,
    useFactory: loadConfig,
    deps: [HttpClient, ConfigService],
    multi: true,
  },
  {
    provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
    useValue: { duration: 15000 },
  },
  provideHttpClient(withInterceptorsFromDi()),
  provideEnvironmentNgxMask(),
] })
export class AppModule {}
